import { PaymentCharge } from '../app/models/paymentcharge';
import { ApplicationFee } from '../app/models/applicationfee';
import { ApplicationFeeInterface } from '../app/interface/applicationfee';
import { ApplicationInvites } from '../app/models/applicationinvites';
import { ApplicationInvitesInterface } from '../app/interface/applicationinvites';
import { CouponValidity } from '../app/models/coupon-validity';
import { CouponValidityInterface } from '../app/interface/coupon-validity';
import { ApplicationDataService } from './application.service';

import { environment } from '../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';


@Injectable()
export class PaymentDataService {
    public static _API_ENDPOINT = environment.apiEndPoint;

    constructor(private http: HttpClient, private applicationService: ApplicationDataService) { }

    createStripeCharge(paymentcharge: PaymentCharge, RentalApplicationKey: string, IsNewTransaction: boolean, waiveApplicantFee: boolean, CouponCode: string) {
        return this.http.post<string>(PaymentDataService._API_ENDPOINT + 'Application/CreateStripeCharge?RentalApplicationKey=' +
            RentalApplicationKey + '&IsNewTransaction=' + IsNewTransaction + "&WaivedApplicantFee=" + waiveApplicantFee + "&CouponCode=" + CouponCode,
            paymentcharge, this.applicationService.createOptions())
            .pipe(
                map((response) => <string>(response)),
                err => err
            );
    }

    getApplicationFeeWithDetails(RentalApplicationKey: string, CouponCode: string = "") {
        return this.http.get<ApplicationFeeInterface>(PaymentDataService._API_ENDPOINT + 'Application/GetApplicationFeeWithDetails?RentalApplicationKey=' +
            RentalApplicationKey + '&CouponCode=' + CouponCode, this.applicationService.createOptions());
    }

    updateMonthlyRentForProperty(RentalApplicationKey: string) {
        return this.http.get<number>(PaymentDataService._API_ENDPOINT + 'Application/UpdateMonthlyRentForProperty?RentalApplicationKey=' +
            RentalApplicationKey, this.applicationService.createOptions());
    }

    getApplicationInviteDetails(RentalApplicationKey: string) {
        return this.http.get<ApplicationInvitesInterface>(PaymentDataService._API_ENDPOINT + 'Application/GetApplicationInviteDetails?RentalApplicationKey=' +
            RentalApplicationKey, this.applicationService.createOptions());
    }

    getStripePublishableKey(PropertyId: string) {
        return this.http.get<string>(PaymentDataService._API_ENDPOINT + 'Application/GetStripePublishableKey?PropertyId=' +
            PropertyId, this.applicationService.createOptions());
    }

    getWaitListCheck(RentalApplicationKey: string) {
        return this.http.post<boolean>(PaymentDataService._API_ENDPOINT + 'Application/CheckForWaitList?RentalApplicationKey=' + RentalApplicationKey,
            RentalApplicationKey,
            this.applicationService.createOptions());
    }

    checkCouponValidity(CouponCode: string) {
        return this.http.get<CouponValidityInterface>(PaymentDataService._API_ENDPOINT + 'Application/CheckCouponValidity?CouponCode=' +
            CouponCode, this.applicationService.createOptions());
    }

}
